import React, {useEffect, useState} from "react";
import Page from "../Components/Page";
import {Breadcrumbs} from "../Components/Breadcrumbs";
import {LoadingWrapper} from "../Components/LoadingWrapper";
import {makeApiCall, makeApiCallDeleteWithData} from "../../Api/makeApiCall";
import {toastError, toastInfo, toastSuccess} from "../../utils/toast";
import {toast} from "react-toastify";
import {SELECT_COLUMN} from "../Components/ReactTable/CheckboxColumnComponent";
import ReactTable from "../Components/ReactTable";
import {getNicelyFormattedNumber} from "../../utils/formatUtil";
import checkCircle from "../../assets/check-circle.svg";
import ConfirmationModal from "../Components/ConfirmationModal";

function IncomingFileService() {
    const endpointUrl = `${process.env.REACT_APP_EDP_API_BASE_URL}/listIncomingGcsFiles/`;

    const [data, setData] = useState({});
    const [loading, setLoading] = useState(true);
    const [triggerRefresh, setTriggerRefresh] = useState(Date.now());

    const [deleteIncomingFileVisible, setDeleteIncomingFileVisible] = useState(false);

    const columns = [
        SELECT_COLUMN,
        {header: "File Name", id: "fileName", filterable: true, accessorKey: "fileName"},
        {header: "Folder Path", id: "folderPath", filterable: true, accessorKey: "folderPath"},
        {header: "Time Created", id: "timeCreated", filterable: true, accessorKey: "timeCreated"}
    ]

    useEffect(() => {
        setLoading(true);
        makeApiCall(endpointUrl).then((result) => {
            setData(result);
            setLoading(false);
        });
    }, [endpointUrl, triggerRefresh]);

    function deleteSelectedFile(selectedRows) {
        const filesToDelete = selectedRows.map(row => row.original.url);
        setDeleteIncomingFileVisible(false)
        toastInfo(
            toast,
            `Deletion of ${selectedRows.length} ${selectedRows.length === 1 ? 'file' : 'files'} has started.`
        );
        setLoading(true);
        makeApiCallDeleteWithData(endpointUrl, filesToDelete).then((response) => {
            if (response?.apiError) {
                console.error("=============> response: ", response)
                toastError(toast, `Operation failed with api error "${JSON.stringify(response.apiError.message)}"`)
                setLoading(false)
            } else {
                toastSuccess(
                    toast,
                    `Successfully removed ${selectedRows.length} ${selectedRows.length === 1 ? 'file' : 'files'}.`
                );
                setTriggerRefresh(Date.now())
            }
        })
    }

    return (
        <Page breadCrumbs={<Breadcrumbs items={[{label: "Services"}, {label: "Incoming Files"}]}/>} beta name={"Incoming Files"}>
            <LoadingWrapper loading={loading}>
                <ReactTable
                    filterable
                    data={data}
                    columns={columns}
                    initialState={{pagination: {pageSize: 25}}}
                >
                    {
                        ({table}) => {
                            const totalRows = getNicelyFormattedNumber(table.getFilteredRowModel().rows.length);
                            const selectedRows = table.getSelectedRowModel().rows;
                            const isAllRowsSelected = table.getIsAllRowsSelected();
                            let selectAllButtonText = `Select all ${totalRows} Incoming Files`;
                            const allRowsSelectedText = `${totalRows} files selected`
                            return (
                                <div className={'designation-action-buttons-container'}
                                     data-testid={"action-button-container"}>
                                    {isAllRowsSelected ?
                                        <>
                                            <img alt={'status'} className={'success-image'} src={checkCircle}/>
                                            <div data-testid={'all-files-selected'}>{allRowsSelectedText}</div>
                                        </>
                                        :
                                        <button data-testid={'select-all-files'} type={"button"}
                                                className={"button tertiary"}
                                                onClick={() => table.toggleAllRowsSelected()}
                                        >{selectAllButtonText}</button>}
                                    <button disabled={selectedRows.length === 0} type={"button"}
                                            className={"button primary"}
                                            onClick={() => setDeleteIncomingFileVisible(true)}>
                                        Delete File
                                    </button>
                                    {deleteIncomingFileVisible && <ConfirmationModal
                                        confirmButtonClass={"danger-button"}
                                        confirmButtonText={"Delete"}
                                        headerText={`Delete ${selectedRows.length === 1 ? 'File' : 'Files'}`}
                                        cancellationCallback={() => setDeleteIncomingFileVisible(false)}
                                        confirmationCallback={() => deleteSelectedFile(selectedRows)}>
                                        {`Delete ${selectedRows.length} ${selectedRows.length === 1 ? 'file' : 'files'} in Incoming Folder?`}
                                    </ConfirmationModal>}
                                </div>
                            )
                        }
                    }
                </ReactTable>
            </LoadingWrapper>
        </Page>
    );
}

export default IncomingFileService;